module.exports = __webpack_public_path__ + "static/media/alarm.a4c190e9.svg";